namespace Matrix.Dashboards {
    export interface DashboardUserForm {
        DashboardCode: Serenity.StringEditor;
        Username: Serenity.StringEditor;
        Default: Serenity.BooleanEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class DashboardUserForm extends Serenity.PrefixedContext {
        static formKey = 'Dashboards.DashboardUser';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DashboardUserForm.init)  {
                DashboardUserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(DashboardUserForm, [
                    'DashboardCode', w0,
                    'Username', w0,
                    'Default', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
